import { LeftCircleOutlined, LoadingOutlined } from "@ant-design/icons";
import { Button, Col, Descriptions, Row, Tag } from "antd";
import { useGetLocationQuery } from "../../redux/services/locationsApi";
import { useNavigate, useParams } from "react-router-dom";

const ViewLocation = (props: any) => {
  const params = useParams();
  const navigate = useNavigate();

  const locationId = params?.locationId;

  const onGoBack = () => {
    navigate(-1);
  };

  const { data, error, isLoading } = useGetLocationQuery(locationId);
  return (
    <>
      {!isLoading && data && (
        <>
          <Row style={{ marginBottom: 20 }}>
            <Col
              sm={24}
              style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
            >
              <h2>Location Details</h2>
              <Button onClick={onGoBack} size="middle" type="default" icon={<LeftCircleOutlined />}>
                Back
              </Button>
            </Col>
          </Row>
          <Descriptions
            title=""
            bordered
            column={1}
            labelStyle={{ fontWeight: 700, width: 300 }}
            size="middle"
          >
            <Descriptions.Item label="Name">{data?.location.name}</Descriptions.Item>
            <Descriptions.Item label="Code">{data?.location.code || "-"}</Descriptions.Item>
            <Descriptions.Item label="Location Type">
              {data?.location.location_type}
            </Descriptions.Item>
            <Descriptions.Item label="Parent State">
              {data?.location?.parent?.location_type === "state"
                ? data?.location?.parent?.name || "-"
                : "-"}
            </Descriptions.Item>
            <Descriptions.Item label="Parent Zone">
              {data?.location?.parent?.location_type === "zone"
                ? data?.location?.parent?.name || "-"
                : "-"}
            </Descriptions.Item>

            <Descriptions.Item label="Status">
              <Tag color={data?.location.status === "active" ? "green" : "red"}>
                {data?.location.status.toUpperCase()}
              </Tag>
            </Descriptions.Item>
          </Descriptions>
        </>
      )}

      {isLoading && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh"
          }}
        >
          <LoadingOutlined style={{ fontSize: 24 }} spin />
        </div>
      )}
    </>
  );
};

export default ViewLocation;
